import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tableusr',
  templateUrl: './tableusr.component.html',
  styleUrls: ['./tableusr.component.scss']
})
export class TableusrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
